module.exports = __webpack_public_path__ + "static/img/DSC_1577_03.39379be3.png";